import { render, staticRenderFns } from "./activity_result.vue?vue&type=template&id=66a6f668&scoped=true&"
import script from "./activity_result.vue?vue&type=script&lang=js&"
export * from "./activity_result.vue?vue&type=script&lang=js&"
import style0 from "./activity_result.vue?vue&type=style&index=0&id=66a6f668&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a6f668",
  null
  
)

export default component.exports